<template>
  <header class="site-header">
    <div class="site-header__inner">
      <RouterLink to="/" class="site-logo">
        <img src="/logo.png" alt="苏州市爱心达人公益慈善基金会" />
      </RouterLink>
      <nav class="site-nav" :class="{ 'is-open': menuOpen }">
        <RouterLink
          v-for="item in navItems"
          :key="item.path"
          :to="item.path"
          class="site-nav__item"
          :class="{ active: isActive(item.path) }"
          @click="menuOpen = false"
        >
          {{ item.label }}
        </RouterLink>
      </nav>
      <button class="menu-toggle" aria-label="菜单" @click="menuOpen = !menuOpen">
        <span></span><span></span><span></span>
      </button>
    </div>
  </header>
</template>

<script>
const NAV_ITEMS = [
  { label: '首页', path: '/' },
  { label: '公益项目', path: '/charityProject' },
  { label: '机构动态', path: '/organDynamic' },
  { label: '行业资讯', path: '/industryInformation' },
  { label: '信息披露', path: '/informationShow' },
  { label: '关于我们', path: '/aboutUs' }
]

export default {
  name: 'SiteHeader',
  data() {
    return {
      navItems: NAV_ITEMS,
      menuOpen: false
    }
  },
  methods: {
    isActive(path) {
      if (path === '/') return this.$route.path === '/'
      return this.$route.path.startsWith(path)
    }
  },
  watch: {
    '$route'() {
      this.menuOpen = false
    }
  }
}
</script>

<style scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.97);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--color-border);
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);
}

.site-header__inner {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 20px;
  height: var(--header-height);
  display: flex;
  align-items: center;
  gap: 32px;
}

.site-logo {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.site-logo img {
  height: 52px;
  width: auto;
  object-fit: contain;
}

.site-nav {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

.site-nav__item {
  padding: 8px 16px;
  font-size: 15px;
  color: var(--color-text-secondary);
  border-radius: 6px;
  transition: all var(--transition);
  white-space: nowrap;
}

.site-nav__item:hover,
.site-nav__item.active {
  color: var(--color-primary);
  background: rgba(192, 57, 43, 0.06);
}

.site-nav__item.active {
  font-weight: 600;
}

.menu-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  padding: 8px;
  background: none;
  border: none;
  cursor: pointer;
}

.menu-toggle span {
  display: block;
  width: 22px;
  height: 2px;
  background: var(--color-text);
  border-radius: 1px;
  transition: var(--transition);
}

@media (max-width: 900px) {
  .menu-toggle {
    display: flex;
    margin-left: auto;
  }

  .site-nav {
    display: none;
    position: absolute;
    top: var(--header-height);
    left: 0;
    right: 0;
    flex-direction: column;
    background: #fff;
    padding: 12px 20px 20px;
    border-bottom: 1px solid var(--color-border);
    box-shadow: var(--shadow);
  }

  .site-nav.is-open {
    display: flex;
  }

  .site-nav__item {
    width: 100%;
    padding: 12px 16px;
  }
}
</style>
